import React, { useState, useEffect } from 'react';
import { InputNumber, Button, message, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { Api_VariavelGlobal } from '../global';

const Config = () => {
  const [valorMinimo, setValorMinimo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Buscar valor mínimo atual no mount
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${Api_VariavelGlobal}/api/delivery/config`);
        if (!res.ok) throw new Error('Erro ao buscar configuraço');
        const data = await res.json();
        if (data?.TARIFA_MINIMA) {
          setValorMinimo(Number(data.TARIFA_MINIMA));
        }
      } catch (error) {
        message.error('Erro ao carregar configuraão');
      }
    };
    fetchConfig();
  }, []);

  // Atualizar valor mínimo no backend
  const handleSave = async () => {
    const valorMinimoNumber = Number(valorMinimo);
    if (isNaN(valorMinimoNumber)) {
      message.error('Informe um valor mínimo válido');
      return;
    }
    setIsLoading(true);
    try {
      const res = await fetch(`${Api_VariavelGlobal}/api/delivery/config`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ TARIFA_MINIMA: valorMinimoNumber.toFixed(2) }),
      });
      if (!res.ok) throw new Error('Erro ao salvar');
      message.success('Configuração atualizada com sucesso!');
    } catch (error) {
      message.error('Erro ao salvar configuração');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <h3>Configurações</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Configurações</Breadcrumb.Item>
        </Breadcrumb>
      <div style={{ marginTop: 20, maxWidth: 200 }}>
        <label><b>Valor mínimo do pedido (R$):</b></label>
        <InputNumber
          min={0}
          step={0.01}
          value={valorMinimo}
          onChange={(value) => setValorMinimo(Number(value))}
          style={{ width: '100%', marginTop: 8 }}
          stringMode
        />
        <Button
          type="primary"
          onClick={handleSave}
          loading={isLoading}
          style={{ marginTop: 10, width: '100%' }}
        >
          Salvar
        </Button>
      </div>
    </div>
  );
};

export default Config;
